import { render, staticRenderFns } from "./DashboardsBI.vue?vue&type=template&id=2c688210&scoped=true&"
import script from "./DashboardsBI.vue?vue&type=script&lang=js&"
export * from "./DashboardsBI.vue?vue&type=script&lang=js&"
import style0 from "./DashboardsBI.vue?vue&type=style&index=0&id=2c688210&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c688210",
  null
  
)

export default component.exports